import React, {
  Component,
  PropTypes,
} from 'react'
import Rx from 'rx-dom'
import { NavLink } from 'react-router-dom'
import { slide as Menu } from 'react-burger-menu'
import {
  Row,
  Col,
} from 'antd'

import Logo from '../../assets/logo.png'
import iconCoins from '../../assets/icon-coin.png'
import _search from '../search'
import { token } from '../../utils'
// import checkedIcon from '../../assets/icons8-Checked-96.png'

import {
  EXTRA_SMALL_DEVICE,
  SMALL_DEVICE,
  MEDIUM_DEVICE,
} from '../../constant'

class header extends Component {
  constructor (props) {
    super(props)
    this.isMenuOpen.bind(this)
  }

  static propTypes = {
    screen: PropTypes.string,
    auth: PropTypes.bool,
    info: PropTypes.object,
    sessionInfo: PropTypes.object,
    onLoadLogout: PropTypes.func,
    onLoadCheckActive: PropTypes.func,
    activeStatus: PropTypes.number,
    onLoadInfo: PropTypes.func,
    pathname: PropTypes.string,
    onChangeRoute: PropTypes.func,
  }
  state = {
    visibleMenu: false,
  }
  componentWillMount () {
    let checkToRedirectUrl = window.location.href.split(':')
    if (checkToRedirectUrl[0] === 'http' && checkToRedirectUrl[1] !== '//localhost' && window.location.href.split(':')[1].split('.')[0] !== '//192') {
      window.location.href = window.location.href.replace('http', 'https')
    }
  }
  componentDidMount () {
    Rx
      .DOM
      .fromEvent(document.body, 'scroll')
      .subscribe(() => {
        this.setState({
          stickyClass: document.body.scrollTop > 5 ? 'scrolling' : '',
        })
      })
    const {
      onLoadInfo,
      // auth,
      // pathname,
      // activeStatus,
    } = this.props
    // this.props.onLoadCheckActive()
    // let checkToRedirectUrl = window.location.href.split(':')
    // if (checkToRedirectUrl[0] === 'http' && checkToRedirectUrl[1] !== '//localhost') {
    //   window.location.href = window.location.href.replace('http', 'https')
    // }

    if (token !== '') {
      onLoadInfo()
      this.props.onLoadCheckActive()
    }
    // if (token !== '' && auth === false) {
    //   window.location.href = '/'
    // }
  }
  isThisPage (pageURL) {
    const {
      pathname,
    } = this.props
    let path = pathname.split('/')
    return pageURL.indexOf(`${path[path.length - 1]}`) > -1 ? '#3fc19c' : ''
  }
  isThisPageNav (pageURL) {
    const {
      pathname,
    } = this.props
    let path = pathname.split('/')
    return pageURL.indexOf(`${path[path.length - 1]}`) > -1 ? 'active-link' : ''
  }

  handleMenu () {
    this.setState({
      visibleMenu: !this.state.visibleMenu,
    })
  }

  isMenuOpen (state) {
    this.setState({
      visibleMenu: state.isOpen,
    })
    return state.isOpen
  }

  isLargeDevice () {
    const {
      screen,
    } = this.props
    return screen !== EXTRA_SMALL_DEVICE && screen !== SMALL_DEVICE && screen !== MEDIUM_DEVICE
  }

  isActive () {
    const {
      activeStatus,
    } = this.props
    if (activeStatus === 2 && this.isLargeDevice()) {
      return (
        <li>
          {/* <a href="/instructor/verify">ร่วมสอนกับเรา</a> */}
          {/* <a href="/instructor">ร่วมสอนกับเรา</a> */}
        </li>
      )
    /* } else if (activeStatus === 1 && this.isLargeDevice()) {
      return (
        <li>
          <a href="/instructor/dashboard" className="manage" style={{ marginBottom: '-5px' }}><div className="spacebetween" style={{ color: this.isThisPage(['instructor']) }}>จัดการคอร์สเรียน</div></a>
        </li>
      ) */
    // } else if (activeStatus === 0 && this.isLargeDevice()) {
    //   return (
    //     <li>
    //       <a href="/instructor/review" style={{ color: this.isThisPage(['instructor']) }}>ผู้สอน</a>
    //     </li>
    //   )
    } else if (activeStatus === 2 && !this.isLargeDevice()) {
      return (
        // <a className="menu-item" href="/instructor/verify">ร่วมสอนกับเรา</a>
        // <a className="menu-item" href="/instructor">ร่วมสอนกับเรา</a>
        <div />
      )
    /* } else if (activeStatus === 1 && !this.isLargeDevice()) {
      return (
        <a className="menu-item" href="/instructor/dashboard" style={{ color: this.isThisPage(['instructor']) }}>จัดการคอร์สเรียน</a>
      ) */
    // } else if (activeStatus === 0 && !this.isLargeDevice()) {
    //   return (
    //     <a className="menu-item" href="/instructor/review" style={{ color: this.isThisPage(['instructor']) }}>ผู้สอน</a>
    //   )
    }
    return ''
  }

  menuLoggedIn = () => {
    const {
      sessionInfo: {
        displayName,
      },
      info: {
        imageURL,
        email,
        coins,
      },
      onLoadLogout,
    } = this.props
    return (
      <ul className="clear-fix" style={{ marginRight: '-30px', marginTop: '-8px' }}>
        {/* <li>
          <a href="/home" style={{ color: this.isThisPage(['']) }}>หน้าแรก</a>
        </li> */}
        <li>
          {/* <a href="/courseOneByOne">เรียนสดตัวต่อตัว</a> */}
        </li>
        {/* <li>
          <a href="/live" style={{ color: this.isThisPage(['live']) }}>เรียนสด</a>
        </li> */}
        {/* <li>
          <a href="/course" style={{ color: this.isThisPage(['course']) }}>เรียนออนไลน์</a>
        </li> */}
        <li>
          <NavLink to="/eTestingHome" activeClassName={this.isThisPageNav(['eTestingHome', 'eTestingSection', 'etestingList', 'eTestingOverview', 'eTestingExample', 'eTestingReviewResult']) }>คลังข้อสอบ</NavLink>
        </li>
        <li>
          <NavLink to="/live" activeClassName={this.isThisPageNav(['live']) }>ติว TCAS 9 วิชา ฟรี</NavLink>
        </li>
        {/* <li>
          <a href="/creators" style={{ color: this.isThisPage(['creators']) }}>ผู้สอน</a>
        </li> */}
        <li >
          <a style={{ color: this.isThisPage(['library', 'setting', 'interest', 'wishlist', 'following']) }}><i className="fa fa-user" /> {displayName}</a>
          <ul className="ul-nobullet" style={{ fontFamily: 'Sukhumvit-light', fontSize: '12px' }} >
            <li>
              <NavLink to="/setting" activeClassName={this.isThisPageNav(['setting']) } style={{ paddingLeft: 0 }}>
                <Row >
                  <Col span={8} >
                    <img className="menu-image" src={imageURL} data-at2x={imageURL} style={{ borderRadius: '50%', marginTop: '10px', marginLeft: '22px', marginBottom: '10px', height: '40px', width: '40px' }} alt="" />
                  </Col>
                  <Col span={16} >
                    <Row>
                      <div style={{ marginLeft: '32px', marginTop: '4px' }}><div style={{ marginBottom: '-10px' }}>{displayName}</div></div>
                    </Row>
                    <Row>
                      <div style={{ fontSize: '12px', marginLeft: '32px', marginBottom: '-10px', marginTop: '-2px' }}>{email}</div>
                    </Row>
                    {/* <Row>
                      <Col span={8} justify="center" align="middle">
                        <img className="menu-image" src={iconCoins} style={{ borderRadius: '50%', marginTop: '5px', marginLeft: '32px', marginBottom: '10px', height: '15px', width: '15px' }} alt="" />
                      </Col>
                      <Col span={8} justify="center" align="middle">
                        <div style={{ fontSize: '12px', marginLeft: '24px', marginBottom: '-10px', marginTop: '-2px' }}>{coins}</div>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>
              </NavLink>
            </li>
            <hr style={{ width: '90%', border: '0', margin: 'auto' }} />
            {/* <li >
              <a onClick={() => window.open('/coin', '_blank', 'location=yes,height=570,width=798,scrollbars=no,status=yes,left=500,top=200')} className="coin" style={{ color: this.isThisPage(['coin']) }}><div className="spacebetween">เติมเหรียญ</div></a>
              <hr style={{ width: '90%', border: '0', margin: 'auto' }} />
            </li> */}
            {/* <li >
              <NavLink to="/library/course" className="library" activeClassName={this.isThisPageNav(['course'])}><div className="spacebetween">คอร์สเรียนของฉัน</div></NavLink>
            </li> */}
            <li >
              <NavLink to="/library/exam" className="libraryExam" activeClassName={this.isThisPageNav(['exam'])}><div className="spacebetween">ข้อสอบของฉัน</div></NavLink>
            </li>
            <hr style={{ width: '90%', border: '0', margin: 'auto' }} />
            <li className="li-checked">
              <NavLink to="/interest" className="interest" activeClassName={this.isThisPageNav(['interest'])} > <div className="spacebetween" style={{ marginBottom: '-5px'}} >สิ่งที่สนใจ</div></NavLink>
            </li>
            <li>
              <NavLink to="/wishlist" className="wishList" activeClassName={this.isThisPageNav(['wishlist'])} ><div className="spacebetween" style={{ marginBottom: '-5px' }} >รายการโปรด</div></NavLink>
            </li>
            {/* <li>
              <a href="/following" className="following" ><div className="spacebetween" style={{ color: this.isThisPage(['following']) }}>กำลังติดตาม</div></a>
            </li> */}
            <li>
              <NavLink to="/etestingHistory" className="historyExam" activeClassName={this.isThisPageNav(['etestingHistory'])} ><div className="spacebetween" style={{ marginBottom: '-5px' }} >ประวัติการสอบ</div></NavLink>
            </li>
            <hr style={{ width: '90%', border: '0', margin: 'auto' }} />
            <li>
              <NavLink to="/howtopay" className="paymentInfo" activeClassName={this.isThisPageNav(['howtopay'])}><div className="spacebetween" style={{ marginBottom: '-5px' }} >วิธีการชำระเงิน</div></NavLink>
            </li>
            <hr style={{ width: '90%', border: '0', margin: 'auto' }} />
            <li>
              {this.isActive()}
            </li>
            {/* <li>
              <a href="/setting">ตั้งค่าบัญชี</a>
            </li> */}
            <li>
              <a onClick={() => onLoadLogout()} className="logout"><div className="spacebetween" >ออกจากระบบ</div></a>
            </li>
          </ul>
        </li>
      </ul>
    )
  }

  menuWithoutLogIn = () => (
    <ul className="clear-fix" style={{ marginRight: '-30px', marginTop: '-8px' }}>
      {/* <li>
        <a href="/home" style={{ color: this.isThisPage(['']) }}>หน้าแรก</a>
      </li> */}
      {/* <li>
        <a href="/live" style={{ color: this.isThisPage(['live']) }}>เรียนสด</a>
      </li> */}
      {/* <li>
        <a href="/course" style={{ color: this.isThisPage(['course']) }}>เรียนออนไลน์</a>
      </li> */}
      <li>
        <a href="/eTestingHome" style={{ color: this.isThisPage(['eTestingHome', 'eTestingSection', 'etestingList', 'eTestingOverview', 'eTestingExample', 'eTestingReviewResult']) }}>คลังข้อสอบ</a>
      </li>
      <li>
        <a href="/live" style={{ color: this.isThisPage(['live']) }}>ติว TCAS 9 วิชา ฟรี</a>
      </li>
      {/* <li>
        <a href="/creators" style={{ color: this.isThisPage(['creators']) }}>ผู้สอน</a>
      </li> */}
      <li>
        {/* <a href="/instructor/signup">ร่วมสอนกับเรา</a> */}
        {/* <a href="/instructor">ร่วมสอนกับเรา</a> */}
      </li>
      {/* <li>
        <a href="/signup" style={{ color: this.isThisPage(['signup']) }}>สมัครสมาชิก</a>
      </li> */}
      <li>
        <a href="/signin" style={{ color: this.isThisPage(['signin']) }}>เข้าสู่ระบบ</a>
      </li>
    </ul>
  )

  menuLogInForSmallDevice = () => {
    const {
      sessionInfo: {
        displayName,
      },
      onLoadLogout,
    } = this.props
    return (
      <Menu
        right
        isOpen={this.state.visibleMenu}
        pageWrapId={'page-wrap'}
        outerContainerId={'outer-container'}
        customBurgerIcon={false}
        onStateChange={this.isMenuOpen.bind(this)}
      >
        <h3 className="menu-item" style={{ paddingBottom: 'unset' }}>{displayName}</h3>
        <hr style={{ border: '0', margin: 'auto' }} />
        {/* <a className="menu-item" href="/home" style={{ color: this.isThisPage(['']) }}>หน้าแรก</a> */}
        {/* <a className="menu-item" href="/courseOneByOne">เรียนสดตัวต่อตัว</a> */}
        {/* <a className="menu-item" href="/live" style={{ color: this.isThisPage(['live']) }}>เรียนสด</a> */}
        {/* <a className="menu-item" href="/course" style={{ color: this.isThisPage(['course']) }}>เรียนออนไลน์</a> */}
        <a className="menu-item" href="/eTestingHome" style={{ color: this.isThisPage(['eTestingHome', 'eTestingSection', 'etestingList', 'eTestingOverview', 'eTestingExample', 'eTestingReviewResult']) }}>คลังข้อสอบ</a>
        <a className="menu-item" href="/live" style={{ color: this.isThisPage(['live']) }}>ติว TCAS 9 วิชา ฟรี</a>
        {/* <a className="menu-item" href="/creators" style={{ color: this.isThisPage(['creators']) }}>ผู้สอน</a> */}
        {/* <a onClick={() => window.open('/coin', '_blank', 'location=yes,height=570,width=798,scrollbars=no,status=yes,left=500,top=200')} className="menu-item" style={{ color: this.isThisPage(['coin']) }}>เติมเหรียญ</a> */}
        <hr style={{ border: '0', margin: 'auto' }} />
        {/* <a className="menu-item" href="/library/course" style={{ color: this.isThisPage(['course']) }}>คอร์สเรียนของฉัน</a> */}
        <a className="menu-item" href="/library/exam" style={{ color: this.isThisPage(['exam']) }}>ข้อสอบของฉัน</a>
        <hr style={{ border: '0', margin: 'auto' }} />
        <a className="menu-item" href="/interest" style={{ color: this.isThisPage(['interest']) }}>สิ่งที่สนใจ</a>
        <a className="menu-item" href="/wishlist" style={{ color: this.isThisPage(['wishlist']) }}>รายการโปรด</a>
        {/* <a className="menu-item" href="/following" style={{ color: this.isThisPage(['following']) }}>กำลังติดตาม</a> */}
        <a className="menu-item" href="/etestingHistory" style={{ color: this.isThisPage(['etestingHistory']) }}>ประวัติการสอบ</a>
        <hr style={{ border: '0', margin: 'auto' }} />
        <a className="menu-item" href="/howtopay" style={{ color: this.isThisPage(['howtopay']) }}>วิธีการชำระเงิน</a>
        <hr style={{ border: '0', margin: 'auto' }} />
        {this.isActive()}
        {/* <a onClick={() => window.open('/coin', '_blank', 'location=yes,height=570,width=798,scrollbars=no,status=yes,left=500,top=200')} className="menu-item" style={{ color: this.isThisPage(['coin']) }}>เติมเหรียญ</a> */}
        <a className="menu-item" href="/setting">ตั้งค่าบัญชี</a>
        <a className="menu-item" onClick={() => onLoadLogout()}>ออกจากระบบ</a>
      </Menu>
    )
  }

  menuWithoutLogInForSmallDevice = () => {
    return (
      <Menu
        right
        isOpen={this.state.visibleMenu}
        pageWrapId={'page-wrap'}
        outerContainerId={'outer-container'}
        customBurgerIcon={false}
        onStateChange={this.isMenuOpen.bind(this)}
      >
        {/* <a id="home" className="menu-item" href="/home" style={{ color: this.isThisPage(['']) }}>หน้าแรก</a> */}
        {/* <a className="menu-item" href="/live" style={{ color: this.isThisPage(['live']) }}>เรียนสด</a> */}
        {/* <a className="menu-item" href="/course" style={{ color: this.isThisPage(['course']) }}>เรียนออนไลน์</a> */}
        <a className="menu-item" href="/eTestingHome" style={{ color: this.isThisPage(['eTestingHome', 'eTestingSection', 'etestingList', 'eTestingOverview', 'eTestingExample', 'eTestingReviewResult']) }}>คลังข้อสอบ</a>
        <a className="menu-item" href="/live" style={{ color: this.isThisPage(['live']) }}>ติว TCAS 9 วิชา ฟรี</a>
        {/* <a id="about" className="menu-item" href="/creators" style={{ color: this.isThisPage(['creators']) }}>ผู้สอน</a> */}
        {/* <a id="about" className="menu-item" href="/instructor">ร่วมสอนกับเรา</a> */}
        {/* <a id="about" className="menu-item" href="/instructor/signup">ร่วมสอนกับเรา</a> */}
        <hr />
        <a href="/signin" className="button-fullwidth cws-button bt-color-3 border-radius" style={{ marginTop: 8 }} >เข้าสู่ระบบ</a>
        {/* <a href="/signup" className="button-fullwidth cws-button bt-color-3 border-radius alt" style={{ marginTop: 8 }}>สมัครสมาชิก</a> */}
      </Menu>
    )
  }

  render () {
    const {
      auth,
    } = this.props
    return (
      <header>
        <div className="sticky-wrapper custom-sticky-wrapper">
          <div
            className={`sticky-menu ${this.state.stickyClass}`}
          >
            {
            this.isLargeDevice() ?
              <div className="grid-row clear-fix">
                <a href="/home" className="logo">
                  <img src={Logo} data-at2x={Logo} alt="logo" style={{ marginLeft: '-40px' }} />
                </a>
                <Col sm={8} xs={6} lg={5} xl={8} xxl={8} style={{ marginTop: '25px', marginLeft: '40px' }}>
                  <aside className="widget-search">
                    <_search />
                  </aside>
                </Col>
                <nav className="main-nav">
                  {
                    auth ? this.menuLoggedIn() : this.menuWithoutLogIn()
                  }
                </nav>
              </div> :
              <div>
                {
                  auth ? this.menuLogInForSmallDevice() : this.menuWithoutLogInForSmallDevice()
                }
                <Row type="flex" align="middle" justify="space-between">
                  <Col
                    xs={{ span: 8, offset: 1 }}
                    sm={{ span: 8, offset: 1 }}
                  >
                    <a href="/home">
                      <img src={Logo} data-at2x="img/logo@2x.png" alt="123" style={{ width: '100%' }} />
                    </a>
                  </Col>
                  <Col
                    sm={4}
                    xs={6}
                    style={{ textAlign: 'right' }}
                  >
                    <i className="fa fa-bars" aria-hidden="true" id="nav-bm" onClick={() => this.handleMenu()} />
                  </Col>
                </Row>
                <Row type="flex" justify="center" style={{ marginTop: '8px' }}>
                  <Col sm={23} xs={22} >
                    <aside className="widget-search">
                      <_search />
                    </aside>
                  </Col>
                </Row>
              </div>
          }
          </div>
        </div>
      </header>
    )
  }
}

export default header



// WEBPACK FOOTER //
// ./src/components/layouts/header.js